/* eslint-disable no-nested-ternary */
import React from "react";
import { useSelector } from "react-redux";
import PropertyContactDashboard from "./PropertyContactDashboard";
import {
  ONBOARDING_PROPERTY_STATUS,
  ONBOARDING_USER_TYPE,
} from "../../../utils/onboarding-helper";
import { useGetCustomer } from "../../../hooks/Onboarding/onboarding.hooks";
import { useSearchOnboardingUser } from "../../../hooks/Onboarding/onboarding-users.hooks";
import { useGetPropertiesByUser } from "../../../hooks/Onboarding/onboarding-properties.hooks";
import PropContactPropertyApprover from "./PropertyApprover/PropContactPropertyApprover";

const PropertyContactHandler = () => {
  const smUser = useSelector((state) => state.api.smData.data);

  const { user_name } = smUser;

  // get property contact user details
  const searchParams = new URLSearchParams({
    email: user_name,
    type: ONBOARDING_USER_TYPE.PROPERTY_CONTACT,
  });

  const { isSuccess: isSuccessPropContact, data: apiPropContactData } =
    useSearchOnboardingUser(searchParams);

  // get property by prop contact
  const {
    data: apiPropertyData,
    isLoading: isLoadingProperties,
    refetch: refetchProperty,
  } = useGetPropertiesByUser(apiPropContactData?._id, {
    enabled: isSuccessPropContact,
    select: (data) => {
      return {
        ...data[0],
      };
    },
  });

  // fetch customer
  const { isSuccess: isSuccessCustomer, data: apiCustomerData } =
    useGetCustomer(apiPropContactData?.customer_id, {
      enabled: isSuccessPropContact,
    });

  return (
    <>
      {isSuccessCustomer &&
      apiPropertyData &&
      apiPropertyData.status === ONBOARDING_PROPERTY_STATUS.APPROVED ? (
        <PropertyContactDashboard
          customer={apiCustomerData}
          corporateContact={
            apiCustomerData?.corporate_contact_id ??
            apiCustomerData?.corporate_contact
          }
          isLoadingProperties={isLoadingProperties}
          properties={[apiPropertyData]}
        />
      ) : apiPropertyData?.status ===
        ONBOARDING_PROPERTY_STATUS.PENDING_APPROVAL ? (
        <PropContactPropertyApprover
          propertyId={apiPropertyData._id}
          refetchProperty={refetchProperty}
        />
      ) : null}
    </>
  );
};
export default PropertyContactHandler;
